import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { useBooth } from '../../../../hooks/useBooth';
import { Booth } from '../../../../interfaces/interfaces';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import validationBuilder from '../../../../static/validations';
import toast from 'react-hot-toast';
import InlineEditTextField from '../../../event/pageBuilder/InlineEditTextField';

interface BoothWebsiteProps {
  booth: Booth;
  isInline?: boolean;
  onUpdate: () => void;
}

export const BoothWebsite = (props: BoothWebsiteProps) => {
  const { booth, isInline, onUpdate } = props;
  // hook form validation has been replaced by states and refs as onBlur+validation+handleSubmit doesn't seem to match and causing some bugs
  // TODO : find a solution for using hook form
  const [isValid, setIsValid] = useState(true);
  const [url, setUrl] = useState<string | undefined>();
  const [isLoading, setIsLoading] = useState(false);

  const event = useSelector((state) => state.admin.event ?? state.common.event);

  useEffect(() => {
    if (booth) setUrl(booth?.websiteUrl);
  }, [booth]);
  const { t } = useTranslation();
  const validations = validationBuilder(t);
  const { updateProp } = useBooth();

  const uiTemplate = event?.template?.uiTemplate || '';

  if (!['vystem-zukunftsrat', 'vystem-light', 'vbw-additive-manufacturing'].includes(uiTemplate)) return <></>;

  function validateUrl(websiteUrl: string) {
    const isUrlValid = !websiteUrl || websiteUrl.match(validations('urlWithoutProtocol').pattern.value);
    setIsValid(!!isUrlValid);
    isInline && setUrl(websiteUrl);
  }
  async function updateExhibitorUrl(websiteUrl: string) {
    if (booth.websiteUrl === websiteUrl || !isValid) return;
    setIsLoading(true);
    try {
      await updateProp(booth._id, 'websiteUrl', websiteUrl);
      onUpdate();
      toast.success(t('common:success'));
    } catch (err) {
      console.error(err);
    }
    setIsLoading(false);
  }

  if (!booth) return null;

  return (
    <div className="mt-5">
      <InlineEditTextField
        className="user-input name-input p-1 "
        fullWidth
        defaultValue={booth.websiteUrl}
        name="websiteUrl"
        onChange={(e) => validateUrl(e.target.value)}
        onBlur={(e) => !isInline && updateExhibitorUrl(e.target.value)}
        label="Website URL"
        style={{ marginTop: '10px' }}
        saveButtonProps={{
          hidden: !isInline || url === booth.websiteUrl,
          onClick: () => updateExhibitorUrl(url ?? ''),
        }}
        loading={isLoading}
      />
      {!isValid && <small style={{ color: 'red' }}>{validations('urlWithoutProtocol').pattern?.message}</small>}
    </div>
  );
};
